import {BaseService} from "./base.service";

class ReportService extends BaseService {

    constructor() {
        super('api/reports')
    }

    getSinistersBySkuAndDateRange(params) {
        return this.http.post(`api/get-clients-sinisters`, params).then(response => response.data).catch(err => err.message);
    }

    generateXlsReport(params) {
        return this.http.post(`api/generate-xls-report`, params).then(response => response.data).catch(err => err.message);
    }

}

export const reportService = new ReportService();
